import React from 'react';
import { Link } from 'react-router';
import glamorous from 'glamorous';
import { dimensions } from '../../../style';

const NotificationCount = glamorous.span({
  position: 'absolute',
  right: -7,
  top: -2,
  fontSize: 12,
  color: '#fff',
  backgroundColor: '#674DAA',
  lineHeight: '14px',
  minWidth: 14,
  textAlign: 'center',
  borderRadius: 10,
  padding: '2px 4px',
  fontWeight: '600',
});

const NavLink = glamorous(Link, {filterProps: ['isActive']})({
  display: 'flex',
  padding: '14px',
  height: '34px',

  [dimensions.SCREEN_MAX_XS]: {
    padding: '8px',
    alignItems: 'center',
    height: '46px'
  }},
  ({isActive}) => (isActive ? {borderBottom: '3px solid #674DAA'} : null),
);

const IconPlaceholder = glamorous.div({
  position: 'relative',
  height: '35px',
  width: '35px',
  verticalAlign: 'middle',
  fill: '#c2c2c2',
});

export default props => {
  const {
    to,
    path,
    currentPath,
    activePathPattern,
    iconComponent,
    activeIconComponent,
    notification,
  } = props;

  let Icon;
  if (iconComponent) {
    Icon = iconComponent;
  }

  return (
    <NavLink to={to} isActive={activePathPattern.test(currentPath)}>
      <IconPlaceholder>
        {notification > 0 && <NotificationCount>{notification > 99 ? '99+' : notification}</NotificationCount>}
        <Icon />
      </IconPlaceholder>
    </NavLink>
  );
};



// WEBPACK FOOTER //
// ./src/components/blocks/HeaderNav/HeaderNavLink.jsx